/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Top_Users_Bar_DescriptionInputs */



/**
* | output |
* | --- |
* | "Highest consumers ranked by total usage" |
*
* @param {Dashboard_Top_Users_Bar_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_top_users_bar_description = /** @type {((inputs?: Dashboard_Top_Users_Bar_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Top_Users_Bar_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Höchste Verbraucher nach Gesamtnutzung")
	return /** @type {LocalizedString} */ ("Highest consumers ranked by total usage")
});